import type { ReactNode } from 'react';

export type PopularFeedResponse = {
	nodes: Array<Record<'id', string>>;
	pageInfo: {
		hasNextPage: boolean;
		hasPreviousPage: boolean;
		startCursor: string;
		endCursor: string;
	};
};

// These options should be in sync with
// https://bitbucket.org/atlassian/cc-analytics/src/efe2fa0fddf3cb426623a0780c93d3870bed936d/cloud/src/components/feeds-api/routes/popular.ts#lines-29
export type Timeframe = 'day' | 'week' | 'default' | 'month' | 'year';

const TIMEFRAMES: Timeframe[] = ['day', 'default', 'week', 'month', 'year'];
const TIMEFRAME_SET = new Set<string>(TIMEFRAMES);

export const getTimeframe = (param?: string): Timeframe => {
	if (param && TIMEFRAME_SET.has(param)) {
		return param as Timeframe;
	}

	return 'default';
};

export interface DiscoverContext {
	cloudId: string;
	placement: 'for-you' | 'discover' | 'sidebar';
	/**
	 * This should indicate both that Confluence is provisioned and that the pre-requisite feature gates are enabled.
	 */
	hasConfluence: boolean;
	/**
	 * This should indicate both that Loom is provisioned and that the pre-requisite feature gates are enabled.
	 */
	hasLoom: boolean;
	/**
	 * Indicates whether AI LLM-related features are enabled.
	 */
	isLLMEnabled: boolean;
}

export type DiscoverTab = 'farewell' | 'welcome' | 'popular';

export const getDiscoverTab = (param?: string): DiscoverTab => {
	if (param === 'farewell' || param === 'welcome') {
		return param;
	}

	return 'popular';
};

export interface DiscoverTabData {
	id: DiscoverTab;
	tab: ReactNode;
}

export interface SpliceInContent {
	after: number;
	content: ReactNode;
}

export type SupportedApp = 'confluence' | 'loom';

export type App = SupportedApp | 'all';

export const getApp = (param?: string): App => {
	if (param === 'confluence' || param === 'loom') {
		return param;
	}

	return 'all';
};
